import { InterventionNonPreventive } from '@/models/InterventionNonPreventive';
import { SortType } from '@/models/SortType';
import { TableHeader } from '@/models/TableHeader';
import { MutationTree } from 'vuex';
import { SUIVI_INTERVENTION } from './mutation-types';
import { initialState as resetState, SuiviInterventionState } from './state';

export const mutations: MutationTree<SuiviInterventionState> = {
    [SUIVI_INTERVENTION.SET_ITEMS](state, items: InterventionNonPreventive[]) {
        state.interventions = items;
    },
    [SUIVI_INTERVENTION.RESET_ITEMS](state) {
        state.interventions = [];
        state.page = 0;
        state.count = 0;
    },
    [SUIVI_INTERVENTION.ADD_ITEMS](state, items: InterventionNonPreventive[]) {
        state.interventions = [...state.interventions, ...items];
    },
    [SUIVI_INTERVENTION.SET_PAGE](state, page: number) {
        state.page = page;
    },
    [SUIVI_INTERVENTION.SET_NB_OF_PAGES](state, pages: number) {
        state.nbOfPages = pages;
    },
    [SUIVI_INTERVENTION.SET_COUNT](state, count: number) {
        state.count = count;
    },
    [SUIVI_INTERVENTION.SET_SCROLL](state, scroll: number) {
        state.scroll = scroll;
    },
    [SUIVI_INTERVENTION.SET_SORT](
        state,
        sort: {
            sortData: string;
            sortStatus: SortType;
        }
    ) {
        const tableHeader = state.tableHeader.reduce((newTable, headerItem) => {
            if (headerItem.sortData !== sort.sortData) {
                if (headerItem.sortStatus !== SortType.INACTIVE) headerItem.sortStatus = SortType.NONE;
            } else headerItem.sortStatus = sort.sortStatus;
            return [...newTable, headerItem];
        }, [] as TableHeader[]);
        state.tableHeader = tableHeader;
        state.sort = sort;
    },
    [SUIVI_INTERVENTION.ADD_FILTER_SITE](state, site: number) {
        state.filterSite = [...state.filterSite, site];
    },
    [SUIVI_INTERVENTION.REMOVE_FILTER_SITE](state, site: number) {
        state.filterSite = state.filterSite.filter(x => x !== site);
    },
    [SUIVI_INTERVENTION.SET_FILTER_SITE](state, siteList: Array<number>) {
        state.filterSite = siteList;
    },
    [SUIVI_INTERVENTION.ADD_FILTER_STATUS](state, status: string) {
        state.filterStatus = [...state.filterStatus, status];
    },
    [SUIVI_INTERVENTION.REMOVE_FILTER_STATUS](state, status: string) {
        state.filterStatus = state.filterStatus.filter(x => x !== status);
    },
    [SUIVI_INTERVENTION.SET_FILTER_STATUS](state, statusList: Array<string>) {
        state.filterStatus = statusList;
    },
    [SUIVI_INTERVENTION.SET_FILTER_INTERVENTION_ID](state, id: string) {
        state.filterInterventionId = id;
    },
    [SUIVI_INTERVENTION.SET_FILTER_PREDICTED_DATE_FROM](state, value: string) {
        state.filterPredictedDateFrom = value;
    },
    [SUIVI_INTERVENTION.SET_FILTER_PREDICTED_DATE_TO](state, value: string) {
        state.filterPredictedDateTo = value;
    },
    [SUIVI_INTERVENTION.RESET_FILTER](state) {
        state.filterSite = [];
        state.filterStatus = [];
        state.filterInterventionId = '';
    },
    [SUIVI_INTERVENTION.SET_IS_LOADING](state, isLoading: boolean) {
        state.isLoading = isLoading;
    },
    [SUIVI_INTERVENTION.SET_ERROR](state, error: Error | undefined) {
        state.error = error;
    },
    [SUIVI_INTERVENTION.CLEAR_ALL](state) {
        Object.assign(state, resetState);
    },

    [SUIVI_INTERVENTION.SET_EXPORT_XLS_IS_LOADING](state, isLoading: boolean) {
        state.isExportXlsLoading = isLoading;
    },

};
